<template>
  <div class="all-style-bgc">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoreportInternet">新闻动态></span>
        <span @click="GoreportEvaluation">{{ type }}></span>
        <span class="red">正文</span>
      </div>
      <!--正文内容-->
      <div class="text">
        <h1>{{ ClassRoonBox.title }}</h1>
        <h2 class="from-box">
          <div class="mg-16">来源：{{ ClassRoonBox.Source }}</div>
          <div class="mg-16">作者：{{ ClassRoonBox.writer }}</div>
          <div class="mg-16">发布时间：{{ ClassRoonBox.updateTime }}</div>
        </h2>
        <div class="ql-container ql-snow" style='min-height: 500px;'>
          <div v-for="(item, index) in imgsArr" :key="index" class="imgStyle">
            <img :src="item.filePath" width="100%" style="margin-bottom: 20px;height: auto" />
          </div>
          <h3 class="ql-editor">{{ ClassRoonBox.description }}</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ClassRoonBox: {
        title: "",
        author: "",
        publishTime: "",
        context: "",
        description: ''
      },
      imgsArr: [],
      type: ''
    };
  },
  created() {
    let obj = JSON.parse(this.$route.query.content);
    // console.log(obj);
    this.type = obj.type
    this.ClassRoonBox.newsId = obj.AOMID;
    this.ClassRoonBox.title = obj.Title;
    this.ClassRoonBox.writer = obj.Author;
    this.ClassRoonBox.updateTime = obj.CreationTime;
    this.ClassRoonBox.Source = obj.Source
    this.searchImgsFun();
  },
  computed: {},
  methods: {
    GoreportInternet() {
      this.$router.push("/forum");
    },
    GoreportEvaluation() {
      if (this.type == '公司新闻') {
        this.$router.push({
          name: "forumClassroom",
        });
      } else {
        this.$router.push({
          name: "forumOutside",
        })
      }

    },
    searchImgsFun() {
      this.Api.SearchNewsByAOMIDApi({
        AOMID: this.ClassRoonBox.newsId,
      }).then((res) => {
        this.ClassRoonBox.description = res.Data.News[0].description;
        let showPictureUrl = res.Data.documentsIISHttp;
        for (let i = 0; i < res.Data.pathfilename.length; i++) {
          this.imgsArr.push(res.Data.pathfilename[i]);
        }
        for (let i = 0; i < res.Data.pathfilename.length; i++) {
          this.imgsArr[i].filePath =
            showPictureUrl +
            res.Data.pathfilename[i].dir +
            res.Data.pathfilename[i].filename;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 80%;
  margin: 0 auto;
}

/*副导航兰*/
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}

.red {
  color: red;
}

/*问卷调查正文*/
.text {
  background-color: white;
  padding: 44px 60px 121px 60px;
  margin: 0 auto;
}

.text h1 {
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 56px;
  text-align: center;
}

.text h2 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 44px;
  text-align: center;
  padding-bottom: 14px;
  border-bottom: 1px solid #e8e8e8;
  margin-bottom: 15px;
}

.text h3 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 32px;
  margin-bottom: 30px;
}

/*静态页面样式 */
.PIC-BOX {
  display: flex;
  justify-content: center;
}

.from-box {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  .mg-16 {
    margin: 0px 16px;
    height: 30px;
    text-align: center;
  }
}

.imgStyle {
  width: 80%;
  margin: 0 auto;
}
</style>
